import { GoogleMap, OverlayViewF, OVERLAY_LAYER } from "@react-google-maps/api";
// @ts-ignore
import "./LocationGoogleMap.scss";
import { LocationPageLocationFragment } from "routes/location/Location.generated";
import { joinClassNames } from "utils/join-class-names";
import pinIcon from "assets/pin.png";

interface LocationGoogleMapProps {
  location: LocationPageLocationFragment;
  className?: string;
}

export const LocationGoogleMap = ({
  location,
  className = ""
}: LocationGoogleMapProps): JSX.Element | null => {
  if (
    location?.address_latitude &&
    location?.address_longitude &&
    (window as any).google &&
    google.maps
  ) {
    return (
      <div className={joinClassNames("location-google-map", className)}>
        <GoogleMap
          zoom={13}
          center={{
            lat: location.address_latitude,
            lng: location.address_longitude
          }}
          options={{ fullscreenControl: false }}
        >
          {/* HTML pin instead of the deprecated google.maps.Marker. */}
          <OverlayViewF
            position={{
              lat: location.address_latitude,
              lng: location.address_longitude
            }}
            mapPaneName={OVERLAY_LAYER}
            getPixelPositionOffset={(width, height) => ({
              x: -width / 2,
              y: -height
            })}
          >
            <img
              src={pinIcon}
              alt={location.name || "Salon location"}
              width={25}
              height={30}
              className="max-w-none"
            />
          </OverlayViewF>
        </GoogleMap>
      </div>
    );
  } else {
    return null;
  }
};
